var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { height: "100%", "min-height": "870px" }
        },
        [
          _c(
            "div",
            {
              class: _vm.gridClass,
              staticStyle: {
                width: "15%",
                "min-width": "190px",
                border: "1px solid #ccc",
                display: "flex",
                cursor: "pointer"
              }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  "min-height": "500px"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.trackingTemplateTree.gridOptions,
                  "column-defs": _vm.trackingTemplateTree.columnDefs,
                  "row-data": _vm.trackingTemplateTree.rowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.optModule.template,
                  expression: "optModule.template"
                }
              ],
              class: _vm.gridClass,
              staticStyle: {
                width: "15%",
                "min-width": "190px",
                border: "1px solid #ccc",
                display: "flex",
                cursor: "pointer"
              }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  "min-height": "500px"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.trackingTree.gridOptions,
                  "column-defs": _vm.trackingTree.columnDefs,
                  "row-data": _vm.trackingTree.rowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "min-width": "85%",
                border: "1px solid #ccc",
                height: "100%"
              }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.isPlatform &&
                        !(
                          _vm.optModule.tracking || _vm.optModule.trackingDetail
                        ),
                      expression:
                        "!isPlatform && !(optModule.tracking || optModule.trackingDetail)"
                    }
                  ],
                  staticClass: "section",
                  staticStyle: { height: "100%" }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isPlatform,
                          expression: "!isPlatform"
                        }
                      ],
                      staticStyle: { height: "28px", margin: "16px" }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opStatus === "read",
                              expression: "opStatus === 'read'"
                            }
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onNewSopTemplate()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_NewSopTemplate"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.opStatus === "read" &&
                                (_vm.trackingTemplate
                                  ? _vm.trackingTemplate.type === 1
                                  : true),
                              expression:
                                "opStatus === 'read' && (trackingTemplate ? trackingTemplate.type === 1 : true)"
                            }
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onEditSopTemplateConfig()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.TemplateApplicationSettings"
                              )
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opStatus === "read",
                              expression: "opStatus === 'read'"
                            }
                          ],
                          attrs: {
                            disabled: !_vm.hasChooseTemplate,
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onCopySopTemplate()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_CopySopTemplate"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opStatus === "read",
                              expression: "opStatus === 'read'"
                            }
                          ],
                          attrs: {
                            disabled: !_vm.hasChooseTemplate,
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onEditSopTemplate()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_EditSopTemplate"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.opStatus === "read" &&
                                !_vm.trackingTemplate.sopStatus,
                              expression:
                                "opStatus === 'read' && !trackingTemplate.sopStatus"
                            }
                          ],
                          attrs: {
                            disabled: !_vm.hasChooseTemplate,
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onUpdateTenantSopStatus()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_EnableSopTemplate"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.opStatus === "read" &&
                                _vm.trackingTemplate.sopStatus,
                              expression:
                                "opStatus === 'read' && trackingTemplate.sopStatus"
                            }
                          ],
                          attrs: {
                            disabled: !_vm.hasChooseTemplate,
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onUpdateTenantSopStatus()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_UnableSopTemplate"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opStatus === "read",
                              expression: "opStatus === 'read'"
                            }
                          ],
                          attrs: {
                            disabled: !_vm.hasChooseTemplate,
                            type: "danger"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onDeleteSopTemplate()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opStatus !== "read",
                              expression: "opStatus !== 'read'"
                            }
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onSaveSopTemplate()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opStatus !== "read",
                              expression: "opStatus !== 'read'"
                            }
                          ],
                          attrs: { type: "default" },
                          on: {
                            click: function($event) {
                              return _vm.onCancelSopTemplate()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                      )
                    ],
                    1
                  ),
                  _c("sop-template-form", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.isPlatform &&
                          (_vm.hasChooseTemplate || _vm.opStatus !== "read"),
                        expression:
                          "!isPlatform && (hasChooseTemplate || opStatus !== 'read')"
                      }
                    ],
                    ref: "sopTemplateForm",
                    attrs: {
                      "op-status": _vm.opStatus,
                      "platform-data": _vm.platformData,
                      form: _vm.trackingTemplate,
                      "open-subscribe": _vm.openSubscribe
                    },
                    on: {
                      "update:platformData": function($event) {
                        _vm.platformData = $event
                      },
                      "update:platform-data": function($event) {
                        _vm.platformData = $event
                      },
                      "update:form": function($event) {
                        _vm.trackingTemplate = $event
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.optModule.tracking ||
                        _vm.optModule.trackingDetail ||
                        (_vm.hasChooseTemplate && _vm.isPlatform),
                      expression:
                        "(optModule.tracking || optModule.trackingDetail || (hasChooseTemplate && isPlatform))"
                    }
                  ],
                  staticClass: "section",
                  staticStyle: { height: "100%" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { height: "28px", margin: "16px" } },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opStatus === "read",
                              expression: "opStatus === 'read'"
                            }
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onNewNode()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NewNode")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opStatus === "read",
                              expression: "opStatus === 'read'"
                            }
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onNewNodeStatus()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NewNodeStatus")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opStatus === "read",
                              expression: "opStatus === 'read'"
                            }
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onEdit()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opStatus === "read",
                              expression: "opStatus === 'read'"
                            }
                          ],
                          attrs: { type: "danger" },
                          on: {
                            click: function($event) {
                              return _vm.onDelete()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opStatus !== "read",
                              expression: "opStatus !== 'read'"
                            }
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onSave()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opStatus !== "read",
                              expression: "opStatus !== 'read'"
                            }
                          ],
                          attrs: { type: "default" },
                          on: {
                            click: function($event) {
                              return _vm.onCancel()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-tabs",
                    {
                      staticStyle: { "margin-left": "16px" },
                      attrs: { type: "card" },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activateTab,
                        callback: function($$v) {
                          _vm.activateTab = $$v
                        },
                        expression: "activateTab"
                      }
                    },
                    [
                      _vm.optModule.tracking
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "nodeSettings",
                              attrs: {
                                name: "nodeSettings",
                                label: _vm.$t("CargoMsg.Cargo_NodeSettings"),
                                lazy: ""
                              }
                            },
                            [
                              _c("tracking-form", {
                                key: "nodeSettings",
                                ref: "nodeSettings",
                                attrs: {
                                  "template-tree-data":
                                    _vm.trackingTemplateTree.rowData,
                                  type: "nodeSettings",
                                  "op-status": _vm.opStatus,
                                  "tracking-form": _vm.tracking,
                                  "tracking-template-form":
                                    _vm.trackingTemplate,
                                  "platform-data": _vm.platformData,
                                  "pre-tracking-options":
                                    _vm.preTrackingOptions,
                                  "tracking-details": _vm.trackingDetails,
                                  "priority-conditions": _vm.priorityConditions,
                                  "specific-business-rules":
                                    _vm.specificBusinessRules,
                                  "tenant-instructions": _vm.tenantInstructions
                                },
                                on: {
                                  "update:opStatus": function($event) {
                                    _vm.opStatus = $event
                                  },
                                  "update:op-status": function($event) {
                                    _vm.opStatus = $event
                                  },
                                  "update:trackingForm": function($event) {
                                    _vm.tracking = $event
                                  },
                                  "update:tracking-form": function($event) {
                                    _vm.tracking = $event
                                  },
                                  "update:trackingTemplateForm": function(
                                    $event
                                  ) {
                                    _vm.trackingTemplate = $event
                                  },
                                  "update:tracking-template-form": function(
                                    $event
                                  ) {
                                    _vm.trackingTemplate = $event
                                  },
                                  "update:platformData": function($event) {
                                    _vm.platformData = $event
                                  },
                                  "update:platform-data": function($event) {
                                    _vm.platformData = $event
                                  },
                                  refresh: _vm.refresh
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.optModule.trackingDetail
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "nodeStatus",
                              attrs: {
                                name: "nodeStatus",
                                label: _vm.$t(
                                  "CargoMsg.Cargo_NodeStatusSettings"
                                ),
                                lazy: ""
                              }
                            },
                            [
                              _c("tracking-detail-form", {
                                key: "nodeStatus",
                                ref: "nodeStatus",
                                attrs: {
                                  type: "nodeStatus",
                                  "op-status": _vm.opStatus,
                                  "tracking-detail": _vm.trackingDetail,
                                  "current-lob": _vm.lob,
                                  "state-with-node-codes":
                                    _vm.stateWithNodeCodes,
                                  "is-platform-code":
                                    _vm.isPlatformTrackingDetailCode,
                                  "trigger-types": _vm.triggerTypes,
                                  "report-template-list":
                                    _vm.reportTemplateList,
                                  "doc-type-map": _vm.docTypeMap,
                                  "sop-external-code-config-list":
                                    _vm.sopExternalCodeConfigList,
                                  "tracking-options": _vm.trackingOptions,
                                  "tracking-detail-options":
                                    _vm.trackingDetailOptions
                                },
                                on: {
                                  "update:opStatus": function($event) {
                                    _vm.opStatus = $event
                                  },
                                  "update:op-status": function($event) {
                                    _vm.opStatus = $event
                                  },
                                  "update:trackingDetail": function($event) {
                                    _vm.trackingDetail = $event
                                  },
                                  "update:tracking-detail": function($event) {
                                    _vm.trackingDetail = $event
                                  },
                                  "update:currentLob": function($event) {
                                    _vm.lob = $event
                                  },
                                  "update:current-lob": function($event) {
                                    _vm.lob = $event
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.optModule.trackingDetail
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "alertSettings",
                              attrs: {
                                name: "alertSettings",
                                label: _vm.$t("CargoMsg.Cargo_AlertSettings"),
                                lazy: ""
                              }
                            },
                            [
                              _c("alert-settings-form", {
                                key: "alertSettings",
                                ref: "alertSettings",
                                attrs: {
                                  type: "alertSettings",
                                  "default-warn-name": _vm.defaultWarnName,
                                  "op-status": _vm.opStatus,
                                  form: _vm.trackingDetail.warningRuleVO,
                                  lob: _vm.lob,
                                  "sop-template-code-list":
                                    _vm.sopTemplateCodeList,
                                  "template-complete-node-status":
                                    _vm.templateCompleteNodeStatus
                                },
                                on: {
                                  "update:defaultWarnName": function($event) {
                                    _vm.defaultWarnName = $event
                                  },
                                  "update:default-warn-name": function($event) {
                                    _vm.defaultWarnName = $event
                                  },
                                  "update:opStatus": function($event) {
                                    _vm.opStatus = $event
                                  },
                                  "update:op-status": function($event) {
                                    _vm.opStatus = $event
                                  },
                                  "update:form": function($event) {
                                    return _vm.$set(
                                      _vm.trackingDetail,
                                      "warningRuleVO",
                                      $event
                                    )
                                  },
                                  "update:templateCompleteNodeStatus": function(
                                    $event
                                  ) {
                                    _vm.templateCompleteNodeStatus = $event
                                  },
                                  "update:template-complete-node-status": function(
                                    $event
                                  ) {
                                    _vm.templateCompleteNodeStatus = $event
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.optModule.trackingDetail
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "sopMessageSetting",
                              attrs: {
                                name: "sopMessageSetting",
                                label: _vm.$t(
                                  "CargoMsg.Cargo_ConfigureSopMessagePush"
                                ),
                                lazy: ""
                              }
                            },
                            [
                              _c("sop-message-setting-form", {
                                key: "sopMessageSetting",
                                ref: "sopMessageSetting",
                                attrs: {
                                  lob: _vm.lob,
                                  "op-status": _vm.opStatus,
                                  type: "sopMessageSetting",
                                  "tracking-list": _vm.trackingTree.rowData,
                                  "tracking-detail": _vm.trackingDetail,
                                  "file-tree-map": _vm.fileTreeMap,
                                  "multiple-trigger": _vm.multipleTrigger
                                },
                                on: {
                                  "update:lob": function($event) {
                                    _vm.lob = $event
                                  },
                                  "update:opStatus": function($event) {
                                    _vm.opStatus = $event
                                  },
                                  "update:op-status": function($event) {
                                    _vm.opStatus = $event
                                  },
                                  "update:trackingDetail": function($event) {
                                    _vm.trackingDetail = $event
                                  },
                                  "update:tracking-detail": function($event) {
                                    _vm.trackingDetail = $event
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _c("sop-template-config-dialog", {
        attrs: { visible: _vm.sopTemplateConfigDialog.visible, lob: _vm.lob },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopTemplateConfigDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }